import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { Utils } from '../../utils';
import '../dataTable/dataTable';
import '../dataTable/dataTablePaging';
import { Postbox, PostboxPaging } from '../postbox/postbox';
import '../dialog/dialog';
import moment = require("moment");
import '../address/address_form';
import '../dialog/stackDialog';
import '../dialog/editDeadlineDialog';
import { ColumnParameters, PagingModel, TableData, TableParametersType } from "../../types/TableTypes";
ko.bindingHandlers.iframeContent = {
    update: function (element, valueAccessor) {
        var value = ko.unwrap(valueAccessor());
        element.contentWindow.document.close();
        element.contentWindow.document.write(value);
    }
};
export class MailboxOverviewViewModel {
    mailsInInbox = ko.observableArray([]);
    entriesforMail = ko.observableArray([]);
    currentFKA = ko.observable("");
    currentState = ko.observable("undone");
    Locations = ko.observableArray([]);
    FKAAccounts = ko.observableArray([]);
    currentMail = ko.observable(null);
    showPDFViewer = ko.observable(false);
    showPDFLoader = ko.observable(false);
    showFileToLarge = ko.observable(false);
    selectedLocationModal = ko.observable("");
    inactiveSidebar = ko.observable(true);
    wrongLocation = ko.observable(false);
    searchValue = ko.observable("");
    currentRubrum = ko.observable("");
    statusModalTitle = ko.observable("");
    statusModalText = ko.observable("");
    showCaseLoader = ko.observable(false);
    selectedCaseId = ko.observable("");
    selectedRubrum = ko.observable("");
    selectedInstanceClerks = ko.observable("");
    selectedCaseInstances = ko.observableArray([]);
    selectedInstanceId = ko.observable(0);
    selectedCaseLocation = ko.observable("");
    values = ko.observable({
        new: ko.observable(true),
        complete: ko.observable(true),
        yellow: ko.observable(true),
        red: ko.observable(true),
        stopped: ko.observable(true),
        interval: ko.observable(true)
    });
    batchEntries = ko.observable(true);
    showContinueWithInstance = ko.observable(false);
    showCompleteWithoutInstance = ko.observable(false);
    showRedirectMail = ko.observable(false);
    showAttachMoreObjects = ko.observable(false);
    showForwardSuccess = ko.observable(false);
    showTransferToLocation = ko.observable(false);
    showFurtherCalculation = ko.observable(false);
    showBatchEntries = ko.observable(false);
    editOldDeadline = ko.observable(false);
    isDeadline = ko.observable(false);
    showEditAppointmentModal = ko.observable(false);
    showEditDeadlineModal = ko.observable(false);
    onInit = ko.observable(true);
    IsEditMode = ko.observable(false);
    appointmentId = ko.observable();
    showBusyIndicatior = ko.observable(false);
    loadMessage = ko.observable(false);
    readMode = ko.observable(false);
    isLoadingEntry = ko.observable(false);
    showRecipients = ko.observable(false);
    showConclusion = ko.observable(false);
    allUsers = ko.observableArray([]);
    recipients = ko.observableArray([]);
    forwardMessage = ko.observable("");
    writeMessage = ko.observable(false);
    showFooter = ko.observable(true);
    hasNoPdfs = ko.observable(false);
    noRecipientsSelected = ko.observable(false);
    deactivateCalculation = ko.observable(false);
    movedDeadlineText = ko.observable("");
    movedPreDeadlineText = ko.observable("");
    movedFVAText = ko.observable("");
    movedPreFVAText = ko.observable("");
    isLink = ko.observable(false);
    showCreateLinkLoader = ko.observable(false);
    showEditinkLoader = ko.observable(false);
    showCompleteLinkLoader = ko.observable(false);
    showDeleteLinkLoader = ko.observable(false);
    showMissedLinkLoader = ko.observable(false);
    showCreateLinkError = ko.observable(false);
    showEditinkError = ko.observable(false);
    showCompleteLinkError = ko.observable(false);
    showDeleteLinkError = ko.observable(false);
    showMissedLinkError = ko.observable(false);
    showVerification = ko.observable(false);
    showDeadlineNotification = ko.observable(false);
    approvePastDate = ko.observable(true);
    FVANote = ko.observable("");
    FVADate = ko.observable("YYYY-MM-DD");
    FVAError = ko.observable(false);
    FVASaveSuccess = ko.observable(false);
    FVASaveError = ko.observable(false);
    FVAGrantedDate = ko.observable("YYYY-MM-DD");
    FVAGrantedNote = ko.observable("");
    FVARejectedReason = ko.observable("");
    optionEntries = ko.observableArray([" Ablehnung durch Gericht vom " + moment().format("DD.MM.YYYY")]);
    notifyVerifyDeadline = ko.observable(false);
    FVAPredeadlineDate = ko.observable("YYYY-MM-DD");
    FVALoader = ko.observable(false);
    verificationType = ko.observable(0);
    extensionReason = ko.observable(null);
    fvaLoaders = ko.observable([]);
    reasonForPostponement = ko.observable("");
    userOfPostponement = ko.observable("");
    mailIdPostponement = ko.observable(0);
    isViewerPostponement = ko.observable(true);
    isLocationSwitch = ko.observable(false);
    DeadlineReasons = ko.observable([]);
    mailTableParameters = ko.observable();
    mailTableData = ko.observable();
    tableParameters = ko.observable();
    tableData = ko.observable();
    linkObjectsWithAttachment = ko.observable(false);
    selectedAttachment = ko.observable(null);
    selectedAttachmentId = ko.observable(0);
    locationsLoaded = ko.observable(false);
    async getMailsForInboxes() {
        const isInbox = ko.toJS(this.mailTableParameters().isInbox);
        const currentLocation = ko.toJS(this.mailTableParameters().locationId);
        if (isInbox === true && currentLocation === "All" && ko.toJS(this.locationsLoaded) === false) {
            return;
        }
        this.mailTableData().isBusyTable(true);
        if (ko.toJS(this.mailTableData().filter) !== "")
            this.mailTableData().isBusySearching(true);
        let mails = [];
        let done = false;
        let startDate = null;
        let endDate = null;
        if (ko.toJS(this.mailTableParameters().done) === "done") {
            done = true;
            startDate = ko.toJS(this.mailTableParameters().start);
            endDate = ko.toJS(this.mailTableParameters().end);
        }
        const paging: PagingModel = {
            page: ko.toJS(this.mailTableParameters().page),
            pagesize: ko.toJS(this.mailTableParameters().pageSize),
            orderby: ko.toJS(this.mailTableParameters().orderBy),
            sortAsc: ko.toJS(this.mailTableParameters().sortAsc),
            location: ko.toJS(this.mailTableParameters().locationId),
            fkaid: ko.toJS(this.mailTableParameters().fkaId),
            filter: ko.toJS(this.mailTableParameters().filter),
            antifilter: ko.toJS(this.mailTableParameters().antifilter),
            user: ko.toJS(this.mailTableParameters().user)
        };
        await RNSAPI.getMails(paging, done, startDate, endDate, ko.toJS(this.mailTableParameters().interval), ko.toJS(this.mailTableParameters().new), ko.toJS(this.mailTableParameters().yellow), ko.toJS(this.mailTableParameters().stopped), ko.toJS(this.mailTableParameters().red)).then((data) => {
            let alldata = data as any;
            this.mailTableData().totalCount(alldata.totalCount);
            mails = alldata.mails;
        }).catch((error) => {
            mails = [];
        });
        this.mailTableData().entries(mails.map((mail) => {
            if (mail.IsProcessed === 0)
                mail.stars = "new";
            else if (mail.IsProcessed === 1)
                mail.stars = "yellow";
            else if (mail.IsProcessed === 2)
                mail.stars = "stopped";
            else if (mail.IsProcessed === 3)
                mail.stars = "red";
            else if (mail.IsProcessed === 4)
                mail.stars = "complete";
            mail.Fetched = moment(mail.ReceivedAt).format("DD.MM.yyyy HH:mm");
            let openCaseHandler = {
                icon: "external-link-alt",
                name: 'Akte in neuem Fenster öffnen',
                action: async () => {
                    window.open(`/#/new/${encodeURIComponent(mail.SuggestedCase)}`);
                }
            };
            let sightHandler = {
                icon: "pencil-alt",
                name: "Sichten",
                action: async () => {
                    if (!ko.toJS(this.isLoadingEntry)) {
                        this.isLoadingEntry(true);
                        this.readMode(false);
                        this.showRecipients(false);
                        this.showConclusion(false);
                        this.loadMessage(true);
                        $('#MailViewModal').modal("show");
                        this.openMail(mail.Id, false);
                    }
                },
                isSelectionEvent: true
            };
            let viewHandler = {
                icon: "eye",
                name: "Ansehen",
                action: async () => {
                    if (!ko.toJS(this.isLoadingEntry)) {
                        this.isLoadingEntry(true);
                        this.readMode(true);
                        this.loadMessage(true);
                        $('#MailViewModal').modal("show");
                        let loadedMail;
                        await RNSAPI.getMailById(mail.Id, true, false, false).then(async (data) => {
                            loadedMail = data as any;
                            this.clearCaseData();
                            this.selectedAttachment(null);
                            this.selectedAttachmentId(0);
                            this.inactiveSidebar(false);
                            this.hasNoPdfs(false);
                            this.showFooter(true);
                            this.showTransferToLocation(false);
                            this.showContinueWithInstance(false);
                            this.showCompleteWithoutInstance(false);
                            this.showRedirectMail(false);
                            this.showAttachMoreObjects(false);
                            this.showBatchEntries(true);
                            this.wrongLocation(false);
                            this.showPDFViewer(false);
                            this.showFileToLarge(false);
                            this.showFurtherCalculation(false);
                            this.showRecipients(false);
                            this.showConclusion(false);
                            this.currentMail(loadedMail);
                            if (loadedMail.LocationId === "")
                                this.switchedLocation();
                            this.selectedLocationModal(loadedMail.LocationId);
                            this.searchValue("");
                            this.noRecipientsSelected(false);
                            if (loadedMail.Attachments.length === 0) {
                                this.inactiveSidebar(false);
                            }
                            if (loadedMail.CaseId !== "") {
                                await this.getCaseData(loadedMail.CaseId);
                                if (loadedMail.InstanceId !== null)
                                    this.selectedInstanceId(loadedMail.InstanceId);
                            }
                            this.loadMessage(false);
                            this.getBatchEntries();
                        }).catch((error) => {
                            setTimeout(() => {
                                this.isLoadingEntry(false);
                                $('#MailViewModal').modal("hide");
                                loadedMail = null;
                                this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Öffnen');
                                this.statusModalText('Beim Öffnen des Eingangs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
                                $("#statusModal").modal('show');
                                this.getMailsForInboxes();
                            }, 1000);
                        });
                    }
                },
                isSelectionEvent: true
            };
            mail.actionHandlers = [];
            if (mail.ReasonForPostponement !== "") {
                mail.actionHandlers.push({
                    icon: "comment-lines",
                    name: mail.ReasonForPostponement,
                    action: async () => {
                    }
                });
            }
            if (mail.SuggestedCase)
                mail.actionHandlers.push(openCaseHandler);
            if (mail.IsProcessed === 4)
                mail.actionHandlers.push(viewHandler);
            else
                mail.actionHandlers.push(sightHandler);
            return mail;
        }));
        this.mailTableData().isBusyTable(false);
        this.mailTableData().isBusySearching(false);
    }
    approvedPostpone() {
        $('#reasonForPostponementModal').modal("hide");
        this.isLoadingEntry(true);
        this.readMode(false);
        this.showRecipients(false);
        this.showConclusion(false);
        this.loadMessage(true);
        $('#MailViewModal').modal("show");
        this.openMail(ko.toJS(this.mailIdPostponement), true);
    }
    async openMail(mailid: number, verified: boolean, reactivate: boolean = false) {
        this.userOfPostponement("");
        this.reasonForPostponement("");
        this.mailIdPostponement(0);
        let loadedMail;
        await RNSAPI.getMailById(mailid, false, reactivate, verified).then(async (data) => {
            loadedMail = data as any;
            if (loadedMail.Id !== undefined) {
                this.clearCaseData();
                this.inactiveSidebar(!ko.toJS(this.linkObjectsWithAttachment));
                this.hasNoPdfs(false);
                this.showFooter(true);
                this.showTransferToLocation(false);
                this.showContinueWithInstance(false);
                this.showCompleteWithoutInstance(false);
                this.showRedirectMail(false);
                this.showAttachMoreObjects(false);
                this.showBatchEntries(false);
                this.wrongLocation(false);
                this.showPDFViewer(false);
                this.showFileToLarge(false);
                this.showFurtherCalculation(false);
                this.currentMail(loadedMail);
                if (loadedMail.LocationId === "")
                    this.switchedLocation();
                this.selectedLocationModal(loadedMail.LocationId);
                this.searchValue("");
                this.readMode(false);
                this.showRecipients(false);
                this.showConclusion(false);
                let hasPDF = false;
                try {
                    for (let i = 0; i < loadedMail.Attachments.length; i++) {
                        if (loadedMail.Attachments[i].IsPDF) {
                            hasPDF = true;
                            break;
                        }
                    }
                }
                catch { }
                if (hasPDF === false) {
                    this.hasNoPdfs(true);
                    this.inactiveSidebar(false);
                }
                else
                    this.hasNoPdfs(false);
                if (loadedMail.CaseId !== "") {
                    await this.getCaseData(loadedMail.CaseId);
                    if (loadedMail.InstanceId !== null)
                        this.selectedInstanceId(loadedMail.InstanceId);
                }
                this.loadMessage(false);
                this.isLoadingEntry(false);
                // ensure the message/attachment selection badge is applied
                this.selectedAttachment(null);
                this.selectedAttachmentId(0);
                this.applyActiveAttachmentBadge();
            }
            else {
                setTimeout(() => {
                    this.showPostponeMailView(true, false, mailid, loadedMail.ReasonForPostponement, loadedMail.VbName);
                }, 1000);
            }
        }).catch((error) => {
            setTimeout(() => {
                this.isLoadingEntry(false);
                $('#MailViewModal').modal("hide");
                loadedMail = null;
                let er = error as any;
                console.log(er);
                let mess = er.responseJSON.Message;
                if (mess === "AlreadyOpened") {
                    this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Posteingang bereits in Bearbeitung');
                    this.statusModalText('Der Posteingang wird bereits von einem anderen Nutzer bearbeitet. Bitte versuchen Sie es später erneut.');
                    $("#statusModal").modal('show');
                }
                else if (mess === "AlreadyDone") {
                    this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Posteingang bereits bearbeitet');
                    this.statusModalText('Der Posteingang wurde bereits bearbeitet und kann unter dem Status ERLEDIGT eingesehen werden.');
                    $("#statusModal").modal('show');
                }
                else {
                    this.statusModalTitle('<i class="fas fa-exclamation-circle  mr-2"></i> Fehler beim Öffnen');
                    this.statusModalText('Beim Öffnen des Eingangs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
                    $("#statusModal").modal('show');
                }
                this.getMailsForInboxes();
            }, 1000);
        });
    }
    async showPDF(index) {
        if (ko.toJS(this.showBatchEntries) === false && ko.toJS(this.showContinueWithInstance) === false && ko.toJS(this.showCompleteWithoutInstance) === false && ko.toJS(this.showRedirectMail) === false && ko.toJS(this.showTransferToLocation) === false && ko.toJS(this.showAttachMoreObjects) === false) {
            this.inactiveSidebar(false);
            this.removeActiveAttachments();

            if (ko.toJS(this.linkObjectsWithAttachment)) {
                this.selectedAttachment(ko.toJS(this.currentMail().Attachments[ko.toJS(index)]));
                this.selectedAttachmentId(ko.toJS(this.currentMail().Attachments[ko.toJS(index)]).AttachmentId);
                this.applyActiveAttachmentBadge();
            }
            else {
                $("#AttachmentObject_" + ko.toJS(index)).addClass("mail-badge-active");
                this.selectedAttachment(null);
                this.selectedAttachmentId(0);
            }

            //$("#AttachmentObject_" + ko.toJS(index)).addClass("mail-badge-active");
            this.showPDFViewer(true);
            this.showFileToLarge(false);
            let file = await this.getAttachmentData(index, true);
            $('#pdf-view').attr('src', file);
        }
        else
            this.openPDF(index);
    }
    async openPDF(index) {
        let file = await this.getAttachmentData(index, false);
        window.open(file);
    }
    async downloadPDF(index) {
        var attachment = this.currentMail().Attachments[ko.toJS(index)];
        if (!attachment.AttachmentData) {
            await RNSAPI.getMailAttachment(this.currentMail().Id, attachment.AttachmentId).then(async (data) => {
                this.currentMail().Attachments[ko.toJS(index)] = data;
            }).catch((error) => {
                console.log(error);
            });
        }
        await this.download(attachment.AttachmentName, this.currentMail().Attachments[ko.toJS(index)].AttachmentData);
    }
    async download(name: string, DocumentData: any) {
        let element = document.createElement('a');
        let doc = DocumentData;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(doc);
        }
        else {
            element.setAttribute('href', 'data:application/octet-stream;charset=utf-16le;base64,' + DocumentData);
            element.setAttribute('download', `${name.trim()}`);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }
    async getAttachmentData(index, showLoader: boolean) {
        var attachment = this.currentMail().Attachments[ko.toJS(index)];
        if (!attachment.AttachmentData) {
            if (showLoader)
                this.showPDFLoader(true);
            await RNSAPI.getMailAttachment(this.currentMail().Id, attachment.AttachmentId).then(async (data) => {
                this.currentMail().Attachments[ko.toJS(index)] = data;
                if (this.currentMail().Attachments[ko.toJS(index)].AttachmentData === null) {
                    this.showFileToLarge(true);
                }
            }).catch((error) => {
                console.log(error);
            });
            this.showPDFLoader(false);
        }
        let DocumentData = this.currentMail().Attachments[ko.toJS(index)].AttachmentData;
        let blob = Utils.base64ToBlob(DocumentData, "application/pdf");
        var file = window.URL.createObjectURL(blob);
        return file;
    }
    async updateMailData(postpone = false, relate = false) {
        let caseId = "";
        let instanceId = 0;
        let reasonForPostponement = "";
        if (relate) {
            caseId = ko.toJS(this.selectedCaseId);
            instanceId = ko.toJS(this.selectedInstanceId);
        }
        if (ko.toJS(this.selectedCaseId))
            caseId = ko.toJS(this.selectedCaseId);
        if (postpone || (!postpone && !relate))
            reasonForPostponement = ko.toJS(this.reasonForPostponement);
        let res = await RNSAPI.updateMailData(ko.toJS(this.currentMail().Id), ko.toJS(this.selectedLocationModal), postpone, caseId, instanceId, reasonForPostponement);
        if (res.Type == "UpdateAccountSuccessful") {
            return true;
        }
        return false;
    }
    async transferToLocation() {
        let succ = await this.updateMailData();
        if (succ) {
            this.isLoadingEntry(false);
            $('#reasonForPostponementModal').modal("hide");
            this.getMailsForInboxes();
            this.showPDFViewer(false);
            this.showFileToLarge(false);
            this.currentMail(null);
            this.inactiveSidebar(true);
            this.hasNoPdfs(false);
        }
    }
    switchLocation() {
        this.showPDFViewer(false);
        this.showFileToLarge(false);
        this.removeActiveAttachments();
        this.showTransferToLocation(true);
    }
    showPostponeMailView(isViewer: boolean, isLocationSwitch: boolean, mailid: any, reasonForPostponement = "", VbName = "") {
        this.isLocationSwitch(isLocationSwitch);
        this.isViewerPostponement(isViewer);
        this.isLoadingEntry(false);
        $('#MailViewModal').modal("hide");
        this.reasonForPostponement(ko.toJS(reasonForPostponement));
        this.userOfPostponement(ko.toJS(VbName));
        this.mailIdPostponement(mailid);
        $('#reasonForPostponementModal').modal("show");
    }
    openPostponementModal() {
        this.showPostponeMailView(false, false, null);
    }
    openPostponementModalLocation() {
        this.showPostponeMailView(false, true, null);
    }
    async postponeMail() {
        let succ = await this.updateMailData(true);
        if (succ) {
            this.isLoadingEntry(false);
            $('#reasonForPostponementModal').modal("hide");
            this.userOfPostponement("");
            this.reasonForPostponement("");
            this.mailIdPostponement(0);
            this.getMailsForInboxes();
            this.showPDFViewer(false);
            this.showFileToLarge(false);
            this.currentMail(null);
            this.inactiveSidebar(true);
            this.hasNoPdfs(false);
        }
    }
    async relateToInstance() {
        this.showPDFViewer(false);
        this.showFileToLarge(false);
        //this.removeActiveAttachments();
        this.showContinueWithInstance(true);
    }
    async openRedirection() {
        await this.redirectMail(false);
    }
    openAttachMoreObjects(){
        this.showAttachMoreObjects(true);
    }

    async redirectMail(isfinish: boolean = false) {
        this.recipients([]);
        let users = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        users = users.map((r) => {
            r.actionHandlers = [{
                    icon: "folder-download",
                    name: 'Empfänger ausw\u00e4hlen',
                    action: () => {
                        let foundUser = this.recipients().filter(a => a.Sachbearbeiter_ID === r.Sachbearbeiter_ID);
                        if (foundUser.length === 0) {
                            r.Notify = true;
                            this.recipients.push(r);
                        }
                    }
                }];
            return r;
        });
        this.allUsers(users);
        this.writeMessage(false);
        this.forwardMessage("");
        if (isfinish === false)
            this.showRedirectMail(true);
    }
    composeMail() {
        this.writeMessage(true);
    }
    showAddresses() {
        this.writeMessage(false);
    }
    async forwardMail() {
        if (ko.toJS(this.showBusyIndicatior) === false) {
            this.showBusyIndicatior(true);
            let res = (await RNSAPI.forwardMail(ko.toJS(this.currentMail).Id, ko.toJS(this.forwardMessage), ko.toJS(this.recipients)));
            if (res.Type === "UpdateAccountSuccessful") {
                this.showForwardSuccess(true);
                setTimeout(() => {
                    this.showMessage();
                    this.showForwardSuccess(false);
                    this.showBusyIndicatior(false);
                }, 3000);
            }
            else
                this.showBusyIndicatior(false);
        }
    }
    removeSB(sb) {
        this.recipients.splice(sb, 1);
        if (ko.toJS(this.recipients).length === 0)
            this.showAddresses();
    }
    async completeMail() {
        this.showCompleteWithoutInstance(true);
    }
    async archiveMailWithoutInstance() {
        this.finalizeMail(true);
    }
    async setBatchView() {
        this.editOldDeadline(false);
        this.showEditDeadlineModal(false);
        this.showEditAppointmentModal(false);
        let succ = await this.updateMailData(false, true);
        if (succ) {
            this.showContinueWithInstance(false);
            this.showBatchEntries(true);
            this.getBatchEntries();
            // keep the active badge visible after switching view
            this.applyActiveAttachmentBadge();
        }
    }
    async getBatchEntries() {
        this.entriesforMail([]);
        await RNSAPI.getEntriesForMail(ko.toJS(this.currentMail).Id, ko.toJS(this.selectedAttachment) !== null ? ko.toJS(this.selectedAttachment).AttachmentId : 0).then((entries) => {
            let res = entries as any;
            this.entriesforMail(res.map(entry => {
                entry.LinkedEntries = this.mapEntries(entry.LinkedEntries);
                return entry;
            }));
            //console.log(res);
            //this.mapEntries(res);
        }).catch((error) => {
            console.log(error);
        });

        // else {
        //     await RNSAPI.getEntriesForAttachment(ko.toJS(this.selectedAttachment).AttachmentId).then((entries) => {
        //         let res = entries as any;
        //         this.mapEntries(res);
        //     }).catch((error) => {
        //         console.log(error);
        //     });
        // }

        // this.entriesforMail([]);
        // await RNSAPI.getEntriesForMail(ko.toJS(this.currentMail).Id).then((entries) => {
        //     let res = entries as any;
        //
        // }).catch((error) => {
        //     console.log(error);
        // });
    }
    mapEntries(res: any) {
        if (res.length > 0) {
            res = res.map((re) => {
                if (ko.toJS(re.Type) === 0) {
                    re.Deadline.FormatedDeadline = moment(re.Deadline.Deadline).format("DD.MM.yyyy");
                    re.Deadline.FormatedPreDeadline = moment(re.Deadline.PreDeadline).format("DD.MM.yyyy");
                    switch (re.Method) {
                        case 0:
                            re.Deadline.DescribedMethod = "Frist angelegt";
                            break;
                        case 1:
                            re.Deadline.DescribedMethod = "Frist verlängert";
                            break;
                        case 2:
                            re.Deadline.DescribedMethod = "Frist erledigt";
                            break;
                        case 3:
                            re.Deadline.DescribedMethod = "Frist gelöscht";
                            break;
                        case 4:
                            re.Deadline.DescribedMethod = "FVA gestellt";
                            break;
                        case 5:
                            re.Deadline.DescribedMethod = "FVA abgelehnt";
                            break;
                        case 6:
                            re.Deadline.DescribedMethod = "FVA bewilligt";
                            break;
                        case 7:
                            re.Deadline.DescribedMethod = "Fristanlage verifiziert";
                            break;
                        case 8:
                            re.Deadline.DescribedMethod = "Fristbearbeitung verifiziert";
                            break;
                        case 9:
                            re.Deadline.DescribedMethod = "Fristerledigung verifiziert";
                            break;
                        case 11:
                            re.Deadline.DescribedMethod = "FVA verifiziert";
                            break;
                        case 12:
                            re.Deadline.DescribedMethod = "Fristanlage abgelehnt";
                            break;
                        case 13:
                            re.Deadline.DescribedMethod = "FVA ablehnung abgelehnt";
                            break;
                        case 14:
                            re.Deadline.DescribedMethod = "Fristerledigung abgelehnt";
                            break;
                    }
                }
                else if (ko.toJS(re.Type) === 1) {
                    re.Appointment.FormatedStart = moment(re.Appointment.StartDate).format("DD.MM.yyyy HH:mm") + " Uhr";
                    re.Appointment.AppointmentTypeName = re.Appointment.AppointmentType.Name;
                    switch (re.Method) {
                        case 0:
                            re.Appointment.DescribedMethod = "Termin angelegt";
                            break;
                        case 1:
                            re.Appointment.DescribedMethod = "Termin bearbeitet";
                            break;
                        case 2:
                            re.Appointment.DescribedMethod = "Termin erledigt";
                            break;
                        case 3:
                            re.Appointment.DescribedMethod = "Termin gelöscht";
                            break;
                        case 7:
                            re.Appointment.DescribedMethod = "Terminanlage verifiziert";
                            break;
                        case 12:
                            re.Appointment.DescribedMethod = "Terminanlage abgelehnt";
                            break;
                    }
                }
                return re;
            });
            return res;
            // this.entriesforMail(res);
        }
    }

    openCurrentBatchView() {
        this.openMail(this.currentMail().Id, false);
    }

    openConclusion()
    {
        this.showConclusion(true)
    }

    resetBatchView() {
        this.isLoadingEntry(false);
        this.showMessage();
        this.showContinueWithInstance(false);
        this.showCompleteWithoutInstance(false);
        this.showRedirectMail(false);
        this.showAttachMoreObjects(false);
        this.showBatchEntries(false);
        this.showTransferToLocation(false);
        this.showFurtherCalculation(false);
    }
    showMessage() {
        if (!ko.toJS(this.hasNoPdfs) && !ko.toJS(this.linkObjectsWithAttachment))
            this.inactiveSidebar(true);

        if(this.currentMail().Attachments.length > 0 && ko.toJS(this.linkObjectsWithAttachment) && ko.toJS(this.showBatchEntries) === false && ko.toJS(this.showContinueWithInstance) === false && ko.toJS(this.showCompleteWithoutInstance) === false && ko.toJS(this.showRedirectMail) === false && ko.toJS(this.showTransferToLocation) === false && ko.toJS(this.showAttachMoreObjects) === false) {
            this.removeActiveAttachments();
            this.selectedAttachment(null);
            this.selectedAttachmentId(0);
            this.applyActiveAttachmentBadge();
        }
        this.showPDFViewer(false);
        this.showFileToLarge(false);
        this.showRedirectMail(false);
    }
    showFT() {
        this.showEditDeadlineModal(false);
        this.showEditAppointmentModal(false);
        this.editOldDeadline(false);
    }
    removeActiveAttachments() {
        if(this.currentMail().Attachments.length > 0 && ko.toJS(this.linkObjectsWithAttachment))
            $("#MessageBadge").removeClass("mailAttachmentActiveBadge");

        for (let i = 0; i < this.currentMail().Attachments.length; i++) {
            $("#AttachmentObject_" + i).removeClass("mail-badge-active");
            $("#AttachmentObject_" + i).removeClass("mailAttachmentActiveBadge");
        }
    }
    // Re-apply the active badge to indicate which message/attachment is selected
    applyActiveAttachmentBadge() {
        try {
            if (!ko.toJS(this.linkObjectsWithAttachment)) return;
            // Clear all first
            this.removeActiveAttachments();
            const mail = this.currentMail();
            if (!mail) return;
            const attId = ko.toJS(this.selectedAttachmentId);
            if (!attId || attId === 0) {
                // highlight full message
                $("#MessageBadge").addClass("mailAttachmentActiveBadge");
                return;
            }
            const atts = mail.Attachments || [];
            const idx = atts.findIndex(a => a.AttachmentId === attId);
            if (idx >= 0) {
                $("#AttachmentObject_" + idx).addClass("mailAttachmentActiveBadge");
            }
        } catch {}
    }
    switchedLocation() {
        if ((ko.toJS(this.selectedLocationModal) !== ko.toJS(this.currentMail().LocationId)) || ko.toJS(this.currentMail().LocationId) && ko.toJS(this.inactiveSidebar() === false)) {
            this.wrongLocation(true);
        }
        else
            this.wrongLocation(false);
    }
    switchedInstance() {
        let instances = ko.toJS(this.selectedCaseInstances);
        if (ko.toJS(this.selectedInstanceId) !== 0) {
            for (let i = 0; instances.length > i; i++) {
                if (instances[i].InstanceId === ko.toJS(this.selectedInstanceId)) {
                    this.selectedLocationModal(ko.toJS(instances[i].Referat));
                    let instanceClerkString = "";
                    for (let j = 0; j < instances[i].Clerks.length; j++) {
                        if (j > 0)
                            instanceClerkString = instanceClerkString + " | " + instances[i].Clerks[j].Name;
                        else
                            instanceClerkString = instances[i].Clerks[j].Name;
                    }
                    this.selectedInstanceClerks(instanceClerkString);
                    break;
                }
            }
        }
        else {
            this.selectedInstanceClerks("");
            this.selectedLocationModal(ko.toJS(this.selectedCaseLocation));
        }
    }
    async getLocations() {
        let res = (await RNSAPI.getReferate()).Payload.Units;
        console.log(res);
        res = res.filter(r => r.Id !== '');
        console.log(res);
        this.Locations(res);
        if (ko.toJS(this.mailTableParameters().isInbox) === true) {
            const userData = (await RNSAPI.getLawFirmUser(RNSAPI.User().username)).Payload;
            let user = await RNSAPI.getCurrentLoggedInUser(); //ToDo: check if can be deleted

            if(user.UseAttachmentWorkflow === "1")
                this.linkObjectsWithAttachment(true);

            if (userData.User.LocationId !== "")
                this.mailTableParameters().locationId(userData.User.LocationId);
        }
        // mark locations as loaded and trigger an update so the inbox loads with the correct location
        this.locationsLoaded(true);
        PostboxPaging.publisher().publish(this.mailTableParameters(), this.mailTableParameters().postboxName);
    }
    async getCaseData(caseId: string) {
        let getCaseData = (await RNSAPI.getExtendedCase(caseId)).Payload;
        this.selectedCaseId(getCaseData.Akte.Registernummer);
        this.selectedRubrum(getCaseData.Akte.Rubrum);
        let emptyInstance = [{ InstanceId: 0, InstanceType: "Keine Instanz wählen", CourtId: "", CourtCase: "" }];
        this.selectedCaseInstances(emptyInstance.concat(getCaseData.Instances));
        this.selectedCaseLocation(getCaseData.Akte.Referat);
        this.selectedInstanceId(ko.toJS(this.selectedCaseInstances)[ko.toJS(this.selectedCaseInstances).length - 1].InstanceId);
        if (getCaseData.Instances.Count > 0) {
            this.selectedLocationModal(getCaseData.Instances[getCaseData.Instances.Count - 1].Referat);
        }
        else {
            this.selectedLocationModal(getCaseData.Akte.Referat);
        }
    }
    clearCaseData() {
        this.selectedCaseId("");
        this.selectedRubrum("");
        this.selectedCaseInstances([]);
    }
    openCase() {
        window.open(`/#/new/${encodeURIComponent(ko.toJS(this.selectedCaseId()))}`);
    }
    openSearchCase() {
        this.showCaseLoader(true);
        this.tableParameters().filter(ko.toJS(this.searchValue));
        this.tableData().updateData(true);
        this.searchCase();
    }
    async searchCase() {
        let cases = [];
        this.tableData().isBusyTable(true);
        if (ko.toJS(this.tableParameters().filter) !== "")
            this.tableData().isBusySearching(true);
        const paging: PagingModel = {
            page: ko.toJS(this.tableParameters().page),
            pagesize: ko.toJS(this.tableParameters().pageSize),
            orderby: ko.toJS(this.tableParameters().orderBy),
            sortAsc: ko.toJS(this.tableParameters().sortAsc),
            location: ko.toJS(this.tableParameters().locationId),
            fkaid: ko.toJS(this.tableParameters().fkaId),
            filter: ko.toJS(this.tableParameters().filter),
            antifilter: "",
            user: ""
        };
        await RNSAPI.getCasesPaging(paging).then((data) => {
            let alldata = data as any;
            this.tableData().totalCount(alldata.totalCount);
            cases = alldata.cases;
        }).catch((error) => {
            cases = [];
        });
        this.tableData().entries(cases.map((c) => {
            c.actionHandlers = [{
                    icon: "window-restore",
                    name: 'Akte in neuem Fenster öffnen',
                    action: async () => {
                        window.open(`/#/new/${encodeURIComponent(c.caseid)}`);
                    }
                }, {
                    icon: "folder-download",
                    name: 'Akte ausw\u00e4hlen',
                    action: async () => {
                        await this.getCaseData(c.caseid);
                        $('#SearchCaseModal').modal('hide');
                    }
                }
            ];
            return c;
        }));
        $('#SearchCaseModal').modal("show");
        this.showCaseLoader(false);
        this.tableData().isBusyTable(false);
        this.tableData().isBusySearching(false);
    }
    removeCase() {
        this.searchValue("");
        this.selectedCaseId("");
        this.selectedRubrum("");
        this.selectedCaseInstances([]);
        this.selectedInstanceId(0);
        this.selectedLocationModal(ko.toJS(this.currentMail()).LocationId);
    }
    async closeSaveModal() {
        if (ko.toJS(this.readMode) === false)
            await RNSAPI.releaseMailForEdition(ko.toJS(this.currentMail).Id);
        this.isLoadingEntry(false);
        $("#MailViewModal").modal("hide");
        this.getMailsForInboxes();
    }
    hasRecipients() {
        const recipients = ko.toJS(this.recipients) || [];
        for (let recipient of recipients) {
            if (recipient && recipient.Notify)
                return true;
            const further = (recipient && recipient.furtherRecipients) || [];
            for (let furtherRecipient of further) {
                if (furtherRecipient && furtherRecipient.Notify)
                    return true;
            }
        }
        return false;
    }
    async endEdition() {
        if (this.hasRecipients() === false) {
            this.noRecipientsSelected(true);
            return;
        }
        else
            this.noRecipientsSelected(false);
        if (ko.toJS(this.showBusyIndicatior) === false) {
            this.showBusyIndicatior(true);
            let res = await RNSAPI.sendMailAndGeneratePDF(ko.toJS(this.currentMail().Id), ko.toJS(this.recipients));
            this.showBusyIndicatior(false);
            this.showBatchEntries(false);
            this.showRedirectMail(false);
            this.showAttachMoreObjects(false);
            this.showConclusion(false);
            this.showFurtherCalculation(true);
        }
    }
    reactivateEntry() {
        this.openMail(this.currentMail().Id, false, true);
    }
    async finalizeMail(furtherEdition: boolean) {
        let archive = ko.toJS(furtherEdition);
        if (archive) {
            await RNSAPI.archiveMail(ko.toJS(this.currentMail().Id), archive);
            this.isLoadingEntry(false);
            $("#MailViewModal").modal("hide");
            this.getMailsForInboxes();
        }
        else
            this.resetBatchView();
    }
    showAppointmentCreation() {
        this.showFooter(false);
        if (ko.toJS(this.IsEditMode) === false) {
            this.appointmentId();
        }
    }
    showDeadlineMakros() {
        this.showFooter(false);
    }
    showFTView() {
        this.showFooter(true);
        this.resetAppointmentCreation();
    }
    showNewDeadlineView() {
        this.showFooter(false);
        this.resetAppointmentCreation();
    }
    resetAppointmentCreation() {
        if (ko.toJS(this.IsEditMode))
            Postbox.publisher().publish((null), "FillNewAppointmentDataInStack");
        this.IsEditMode(false);
        this.appointmentId();
    }
    async showMailRecipients() {
        this.showBusyIndicatior(true);
        if (ko.toJS(this.allUsers).length == 0)
            await this.redirectMail(true);
        await RNSAPI.getRecipientsForMail(ko.toJS(this.currentMail).Id).then((entries) => {
            this.showRecipients(true);
            this.showConclusion(false);
            this.showAttachMoreObjects(false);
            this.writeMessage(false);
            this.showBusyIndicatior(false);
            this.showRedirectMail(true);
            let clerks = entries as any;
            clerks = clerks.map((c) => {
                c.isSuggestion = true;
                c.Notify = true;
                c.Sachbearbeiter_ID = c.SachbearbeitertId;
                c.Sachbearbeiter = c.FullName;
                c.Mail = c.Email;
                return c;
            });

            this.recipients(clerks);
        }).catch(error => {
            this.showBusyIndicatior(false);
        });
    }
    showFTs() {
        this.showRedirectMail(false);
        this.showAttachMoreObjects(false);
        this.showRecipients(false);
        this.showConclusion(false);
    }
    constructor() {
        const mailColumns: ColumnParameters[] = [
            { columnHeader: "status", column: "stars", sortable: true },
            { columnHeader: "Betreff", column: "Subject", sortable: true },
            { columnHeader: "Abgeholt am", column: "Fetched", sortable: true },
            { columnHeader: "Aktenvorschlag", column: "SuggestedCase", sortable: false },
            { columnHeader: "Rubrum", column: "Rubrum", sortable: false },
            { columnHeader: "Zuletzt bearbeitet", column: "LastEditor", sortable: false },
            { columnHeader: "Nachricht", column: "BeaMessageId", sortable: true },
            { columnHeader: "Absender", column: "SenderName", sortable: true }
        ];
        const mailTable: TableParametersType = {
            page: ko.observable(0),
            pageSize: ko.observable('30'),
            count: ko.observable(0),
            locationId: ko.observable("All"),
            fkaId: ko.observable(""),
            filter: ko.observable(""),
            orderBy: ko.observable(""),
            sortAsc: ko.observable(true),
            interval: ko.observable("true"),
            done: ko.observable("undone"),
            new: ko.observable(true),
            yellow: ko.observable(true),
            stopped: ko.observable(true),
            red: ko.observable(true),
            start: ko.observable(null),
            end: ko.observable(null),
            antifilter: ko.observable(""),
            user: ko.observable(""),
            type: ko.observable(null),
            instance: ko.observable(null),
            eEB: ko.observable(null),
            activeSelection: true,
            hasActions: true,
            columns: mailColumns,
            emptyMessage: 'Keine Eingänge vorhanden.',
            hasAddressButton: false,
            hasTabs: false,
            hasButton: false,
            showCaseViewButton: false,
            hasDTLayout: true,
            isCaseSearch: false,
            isInbox: true,
            isOutbox: false,
            isMailbox: false,
            postboxName: "UpdateMailTableInbox"
        };
        this.mailTableParameters(mailTable);
        const mailTableData: TableData = {
            entries: ko.observableArray([]),
            totalCount: ko.observable(0),
            updateData: ko.observable(false),
            isBusySearching: ko.observable(false),
            isBusyTable: ko.observable(false)
        };
        this.mailTableData(mailTableData);
        const columns: ColumnParameters[] = [
            { columnHeader: "Akte", column: "caseid", sortable: true },
            { columnHeader: "Rubrum", column: "rubrum", sortable: true },
            { columnHeader: "AZ 1. Instanz", column: "court_caseid_1", sortable: true },
            { columnHeader: "AZ 2. Instanz", column: "court_caseid_2", sortable: true },
            { columnHeader: "AZ 3. Instanz", column: "court_caseid_3", sortable: true }
        ];
        const table: TableParametersType = {
            page: ko.observable(0),
            pageSize: ko.observable('10'),
            count: ko.observable(0),
            locationId: ko.observable(""),
            fkaId: ko.observable(""),
            filter: ko.observable(""),
            orderBy: ko.observable(""),
            sortAsc: ko.observable(false),
            interval: ko.observable("false"),
            done: ko.observable(""),
            new: ko.observable(false),
            yellow: ko.observable(false),
            stopped: ko.observable(false),
            red: ko.observable(false),
            start: ko.observable(null),
            end: ko.observable(null),
            antifilter: ko.observable(""),
            user: ko.observable(""),
            type: ko.observable(null),
            instance: ko.observable(null),
            eEB: ko.observable(null),
            activeSelection: false,
            hasActions: true,
            columns: columns,
            emptyMessage: 'Keine Akten vorhanden.',
            hasAddressButton: false,
            hasTabs: true,
            hasButton: false,
            showCaseViewButton: false,
            hasDTLayout: true,
            isCaseSearch: true,
            isInbox: false,
            isOutbox: false,
            isMailbox: false,
            postboxName: "UpdateCaseTableInbox"
        };
        this.tableParameters(table);
        const tableData: TableData = {
            entries: ko.observableArray([]),
            totalCount: ko.observable(0),
            updateData: ko.observable(false),
            isBusySearching: ko.observable(false),
            isBusyTable: ko.observable(false)
        };
        this.tableData(tableData);
        PostboxPaging.publisher().subscribe((tableparams) => {
            this.searchCase();
        }, this.tableParameters().postboxName);
        PostboxPaging.publisher().subscribe((tableparams) => {
            this.getMailsForInboxes();
        }, this.mailTableParameters().postboxName);
        this.getLocations();
        this.selectedLocationModal.subscribe(() => {
            if (this.currentMail() !== null)
                this.switchedLocation();
        });
        this.selectedInstanceId.subscribe(() => {
            this.switchedInstance();
        });

        const markCurrentSelectionConnected = () => {
            try {
                const mail = this.currentMail();
                if (!mail) return;
                const attId = ko.toJS(this.selectedAttachmentId);
                if (attId && attId !== 0) {
                    // mark the specific attachment as connected
                    const atts = mail.Attachments || [];
                    const idx = atts.findIndex(a => a.AttachmentId === attId);
                    if (idx >= 0) {
                        atts[idx].IsConnected = true;
                    }
                } else {
                    // mark the full message as connected
                    mail.IsConnected = true;
                }
                // notify KO that currentMail object mutated
                if (typeof (this.currentMail as any).valueHasMutated === 'function') {
                    (this.currentMail as any).valueHasMutated();
                } else {
                    // fallback: reassign to trigger update
                    this.currentMail(Object.assign({}, mail));
                }
            } catch {}
        };
        PostboxPaging.publisher().subscribe(() => {
            this.setBatchView();
            Postbox.publisher().publish(true, "updateTFW");
            // After creating/linking an entry, reflect connection state immediately in UI
            markCurrentSelectionConnected();
            // and ensure the selected badge stays highlighted
            this.applyActiveAttachmentBadge();
        }, "GetEntriesInStackCreation");
        PostboxPaging.publisher().subscribe(() => {
            this.getBatchEntries();
        }, "LoadLinkedEntrys");
        PostboxPaging.publisher().subscribe((deadlineObject) => {
            this.showEditAppointmentModal(false);
            this.editOldDeadline(true);
            this.showEditDeadlineModal(true);
            PostboxPaging.publisher().publish(deadlineObject, "EditDeadlineModalData");
        }, "ShowDeadlineHistory");
        PostboxPaging.publisher().subscribe((appointmentObject) => {
            this.editOldDeadline(true);
            this.showEditAppointmentModal(true);
            PostboxPaging.publisher().publish(appointmentObject, "EditAppointmentModalData");
        }, "ShowAppointmentHistory");
        PostboxPaging.publisher().subscribe((appointment) => {
            this.IsEditMode(true);
            this.showFooter(false);
            $("#pills-ftw").removeClass("active show");
            $("#pills-newAppointment").addClass("active show");
            $("#pills-ftw-tab").removeClass("active");
            $("#pills-newAppointment-tab").addClass("active");
        }, "ShowAppointmentEditionModal");
        PostboxPaging.publisher().subscribe(() => {
            $("#pills-ftw").addClass("active show");
            $("#pills-newAppointment").removeClass("active show");
            $("#pills-ftw-tab").addClass("active");
            $("#pills-newAppointment-tab").removeClass("active");
            // mark connection after successful appointment save/link
            markCurrentSelectionConnected();
            this.applyActiveAttachmentBadge();
            this.resetAppointmentCreation();
        }, "ShowFTAfterUpdateAppointment");
        PostboxPaging.publisher().subscribe(() => {
            $("#pills-ftw").addClass("active show");
            $("#pills-newMakro").removeClass("active show");
            $("#pills-ftw-tab").addClass("active");
            $("#pills-newMakro-tab").removeClass("active");
            this.setBatchView();
            this.showFTView();
            Postbox.publisher().publish(true, "updateTFW");
            // also reflect connection after macro-based entry creation
            markCurrentSelectionConnected();
            this.applyActiveAttachmentBadge();
        }, "ShowFTAfterMakroEntry");
    }
    dispose() {
        PostboxPaging.publisher().unsubscribe(this.tableParameters().postboxName);
        PostboxPaging.publisher().unsubscribe(this.mailTableParameters().postboxName);
        PostboxPaging.publisher().unsubscribe("GetEntriesInStackCreation");
        PostboxPaging.publisher().unsubscribe("setEditOldDeadlineView");
        PostboxPaging.publisher().unsubscribe("ShowDeadlineHistory");
        PostboxPaging.publisher().unsubscribe("ShowAppointmentHistory");
        PostboxPaging.publisher().unsubscribe("ShowDeadlineExtension");
        PostboxPaging.publisher().unsubscribe("ShowAppointmentEditionModal");
        PostboxPaging.publisher().unsubscribe("ShowFTAfterUpdateAppointment");
        PostboxPaging.publisher().unsubscribe("ShowFTAfterMakroEntry");
    }
}
let html = fs.readFileSync(__dirname + '/overview.html', 'utf8');
ko.components.register("mailboxOverview-view", {
    viewModel: MailboxOverviewViewModel,
    template: html
});
